export default __webpack_public_path__ + "static/media/4.25aa1d2f.svg";